var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { map, switchMap, catchError, debounceTime } from 'rxjs/operators';
import { of } from 'rxjs';
import * as SearchHistoryActions from '../actions/search-history.action';
import { SearchHistoryActionTypes } from '../actions/search-history.action';
import { StatisticsService } from '@shared/services/statistics.service';
export class SearchHistoryEffects {
    constructor(actions$, statisticsService) {
        this.actions$ = actions$;
        this.statisticsService = statisticsService;
        this.loadSubgroups$ = this.actions$.pipe(ofType(SearchHistoryActionTypes.SearchHistoryLoad), debounceTime(300), switchMap(() => {
            return this.statisticsService.getSearchHistory({ limit: 20 }).pipe(map(history => new SearchHistoryActions.SearchHistoryLoadSuccess(history)), catchError(error => of(new SearchHistoryActions.SearchHistoryLoadFail(error))));
        }));
    }
}
__decorate([
    Effect(),
    __metadata("design:type", Object)
], SearchHistoryEffects.prototype, "loadSubgroups$", void 0);
